import React from 'react'

const Loading = ({className }) => {
    return(
        <div className={`text-center  ${!className ? 'padding-100' : className} `}>
            <span className="kt-spinner kt-spinner--v2 kt-spinner--lg kt-spinner--info"></span>
        </div>  
    );
};

export default Loading;